import styled from 'styled-components'

export const Overview = styled.div`
    display: flex;
    justify-content: space-between;
`
